<script setup>
import requests from '@/OfOnboardingRequests';
import { onMounted, ref } from 'vue';
import OfEntityListHeader from "@dk.onlinefundraising/vue-utils/src/utils/OfEntityListHeader.vue";
import OfTable from "@dk.onlinefundraising/vue-utils/src/utils/OfTable.vue";
import OfUserModal from "./OfUserModal.vue";
import OfCreateUserModal from "./OfCreateUserModal.vue";
import { userAllowed } from '@/functions';

const users = ref([])
const selectedUser = ref()
const createUser = ref(false)

async function getUsers() {
    users.value = await requests.getUsers()
}
onMounted(() => {
    getUsers();
})
</script>
<template>
    <div class="users">
        <OfEntityListHeader v-if="userAllowed('CREATE_USER')" title="Users" :default-filters="{}" extra-button="Create new"
            @extra-click="createUser = true" />

        <OfEntityListHeader v-else title="Users" :default-filters="{}" />

        <OfTable type="entity">
            <template #thead>
                <th>Name</th>
                <th>Email</th>
                <th>User role</th>
            </template>

            <template #tbody>

                <tr v-for="user in users" :key="user.userGuid" @click="selectedUser = user">

                    <td>
                        {{ user.name }}
                    </td>

                    <td>
                        {{ user.email }}
                    </td>

                    <td>
                        {{ user.role }}
                    </td>

                </tr>

                <tr v-if="!users || !users.length">
                    <td colspan="3">
                        No results found
                    </td>
                </tr>

            </template>

        </OfTable>

        <OfUserModal v-if="selectedUser" :user="selectedUser" @close="selectedUser = null" @get-users="getUsers"/>

        <OfCreateUserModal v-if="createUser" @close="createUser = false" @get-users="getUsers" />

    </div>

</template>
<style scoped>
.users :deep(.of-modal) {
    max-width: 700px;
    max-height: 700px;
}
</style>